"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKey = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../../actions");
var initialState = {
  loading: false
};
var getKey = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.getTotpKeyAction.pending, function (state) {
    state.loading = true;
  });
  builder.addCase(_actions.getTotpKeyAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.getTotpKeyAction.fulfilled, function (state, action) {
    state.loading = false;
    state.data = action.payload;
  });
  builder.addCase(_actions.resetGetTotpKeyAction, function () {
    return initialState;
  });
});
exports.getKey = getKey;